import {Component, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {LoadingService} from "./shared/core/services/loader/loading.service";
import {ToastrService} from "ngx-toastr";
import {Title} from "@angular/platform-browser";
import {EnvironmentService} from "./shared/core/services/all-modules-services/environment.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Wacni ';
  isLoading$ = this.loaderService.loading$;
  loadingMessage$ = this.loaderService.message$;

  deferredPrompt: any;
  showInstallButton = false;


  constructor(private translate: TranslateService,
              private loaderService: LoadingService,
              private toastr: ToastrService,
              private env: EnvironmentService,
              private titleService: Title) {
    // Set default language
    this.translate.setDefaultLang('en');
    this.titleService.setTitle(this.env.getTitle());

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.showInstallButton = true;
    });
  }

  ngOnInit() {
  }
  changeLanguage(lang: string) {
    this.translate.use(lang);
  }

  installApp() {
    this.showInstallButton = false;
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        this.deferredPrompt = null;
      });
    }
  }
}
